/**
 * Stylised Saint Petersburg skyline silhouette.
 * Left → right: Rostral column, Peter & Paul spire (with angel),
 * Kunstkamera tower, St. Isaac's dome, the Admiralty needle, embankment.
 * Filled with `currentColor`; tiny lit windows twinkle.
 */
export default function Skyline({ className }: { className?: string }) {
  // Окна-точки в силуэте (мерцают разнобоем)
  const windows = [
    [250, 250], [275, 258], [300, 250], [325, 262],
    [560, 252], [585, 244], [610, 256], [635, 248], [660, 258],
    [900, 250], [925, 260], [950, 252], [975, 262],
    [1130, 255], [1155, 248], [1180, 258],
  ];

  return (
    <svg
      viewBox="0 0 1440 300"
      preserveAspectRatio="xMidYMax slice"
      className={className}
      aria-hidden
    >
      <g fill="currentColor">
        {/* линия набережной / воды */}
        <rect x="0" y="286" width="1440" height="14" />

        {/* ── Ростральная колонна (слева) ── */}
        <rect x="120" y="150" width="14" height="138" />
        <path d="M113 150 h28 l-4 -10 h-20 z" />
        <circle cx="127" cy="132" r="9" />
        {/* «носы» кораблей */}
        <path d="M134 175 q22 4 26 16 l-26 2 z" />
        <path d="M120 175 q-22 4 -26 16 l26 2 z" />

        {/* ── Петропавловский собор: шпиль с ангелом ── */}
        <rect x="300" y="120" width="40" height="168" />
        {/* барабан колокольни */}
        <path d="M300 120 h40 l-6 -16 h-28 z" />
        {/* золотой шпиль-игла */}
        <path d="M318 104 l2 -78 l2 78 z" />
        <path d="M316 30 l4 -22 l4 22 z" />
        {/* ангел с крестом */}
        <circle cx="320" cy="6" r="3.4" />
        <rect x="319" y="-9" width="2" height="8" />

        {/* ── Кунсткамера: башня с глобусом ── */}
        <rect x="470" y="200" width="120" height="88" />
        <rect x="512" y="150" width="36" height="56" />
        <path d="M512 150 h36 l-6 -14 h-24 z" />
        <circle cx="530" cy="124" r="13" />
        <path d="M530 109 l1.6 -16 l1.6 16 z" />

        {/* ── Низкая дворцовая застройка ── */}
        <rect x="600" y="232" width="190" height="56" />
        <path d="M600 232 h190 v-8 h-190 z" />

        {/* ── Исаакиевский собор: большой купол ── */}
        <rect x="800" y="214" width="150" height="74" />
        {/* барабан с колоннами */}
        <rect x="838" y="150" width="74" height="66" />
        <g>
          <rect x="846" y="152" width="4" height="62" />
          <rect x="864" y="152" width="4" height="62" />
          <rect x="882" y="152" width="4" height="62" />
          <rect x="900" y="152" width="4" height="62" />
        </g>
        {/* золотой купол */}
        <path d="M838 152 q37 -64 74 0 z" />
        {/* фонарик + крест */}
        <rect x="869" y="92" width="12" height="24" />
        <path d="M869 92 q6 -14 12 0 z" />
        <rect x="874" y="74" width="2" height="14" />
        <rect x="869" y="79" width="12" height="2" />
        {/* четыре угловые колоколенки */}
        <rect x="806" y="188" width="14" height="26" />
        <circle cx="813" cy="186" r="8" />
        <rect x="930" y="188" width="14" height="26" />
        <circle cx="937" cy="186" r="8" />

        {/* ── Адмиралтейство: игла со «спб-корабликом» ── */}
        <rect x="1080" y="206" width="120" height="82" />
        <rect x="1126" y="150" width="28" height="60" />
        <path d="M1126 150 h28 l-5 -14 h-18 z" />
        {/* золотая игла */}
        <path d="M1138 136 l2 -96 l2 96 z" />
        {/* кораблик-флюгер */}
        <path d="M1132 44 q8 -6 16 0 l-2 6 h-12 z" />
        <rect x="1139" y="30" width="2" height="14" />

        {/* ── Правая малоэтажная застройка ── */}
        <rect x="1240" y="236" width="200" height="52" />
        <path d="M1300 236 v-18 h10 v18 z" />
        <path d="M1360 236 v-26 h8 v26 z" />
      </g>

      {/* мерцающие окна */}
      <g>
        {windows.map(([x, y], i) => (
          <circle
            key={i}
            cx={x}
            cy={y}
            r="2.2"
            fill="#e6c976"
            style={{
              animation: `twinkle ${2.6 + (i % 4) * 0.4}s ease-in-out infinite`,
              animationDelay: `${(i % 6) * 0.35}s`,
            }}
          />
        ))}
      </g>
    </svg>
  );
}
